import apiClient from '../../../data/repositories/apiClient.js';
import { fixImageUrl } from '../../../utils/urlFixer.js';

export const uploadFile = async (file) => {
    if (!file) {
        throw new Error('No file provided');
    }

    console.log('Uploading file:', file.name, 'Size:', file.size, 'Type:', file.type);

    const formData = new FormData();
    formData.append('file', file);

    try {
        const data = await apiClient.upload('/uploads/single', formData);
        console.log('Upload response:', data);
        console.log('Upload response type:', typeof data);
        console.log('Upload response keys:', Object.keys(data || {}));
        console.log('Upload response JSON:', JSON.stringify(data, null, 2));
        
        // Try to extract URL from various possible response formats
        let url = data.fileUrl || data.url || data.imageUrl || data.avatarUrl || data.coverImageUrl || data.buildingImageUrl || data.data?.url;
        
        if (!url) {
            console.error('No URL in response:', data);
            console.error('Trying alternative extraction methods...');
            
            // Try more extraction methods
            if (typeof data === 'string') {
                url = data;
                console.log('Response is a string, using as URL:', url);
            } else if (data.data && typeof data.data === 'string') {
                url = data.data;
                console.log('Response.data is a string, using as URL:', url);
            } else if (Array.isArray(data) && data.length > 0) {
                url = data[0];
                console.log('Response is an array, using first element:', url);
            } else if (data.file && typeof data.file === 'string') {
                url = data.file;
                console.log('Using data.file:', url);
            } else if (data.image && typeof data.image === 'string') {
                url = data.image;
                console.log('Using data.image:', url);
            } else if (data.result && typeof data.result === 'string') {
                url = data.result;
                console.log('Using data.result:', url);
            } else {
                // Try to find any string value that looks like a URL
                const values = Object.values(data || {});
                const urlValue = values.find(v => typeof v === 'string' && (v.startsWith('http') || v.startsWith('/')));
                if (urlValue) {
                    url = urlValue;
                    console.log('Found URL in object values:', url);
                }
            }
        }
        
        if (!url) {
            console.error('Still no URL found after all attempts');
            console.error('Response structure:', data);
            throw new Error('No URL returned from upload');
        }
        
        console.log('Extracted URL before fixing:', url);
        
        // Fix URLs that point to old test servers
        url = fixImageUrl(url);
        console.log('Fixed URL:', url);
        
        return url;
    } catch (error) {
        console.error('Upload error:', error);
        throw error;
    }
};
